export default "__VITE_ASSET__ZOPrqs$u__"